export default __webpack_public_path__ + "static/media/sadiqatiapp.249c07d6.jpg";